import React, { Component } from 'react';

class WeatherSaved extends Component {
    render() {
        return (
            <div className= "panel panel-default">
                <div className ="panel-heading">
                    <h3>My Locations</h3>
                </div>
                <ol>
                    {this.props.cities.map((item, index) => {
                        return (
                            <li key={index}>{item}
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.props.onSavedItemClick(item);
                                    }}
                                >{" View Weather"}</a>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    this.handleItemRemoved(item);
                                }}
                                >  Remove</a>

                            </li>


                        );


                    })}
                </ol>
            </div>
        );
    }
    handleItemRemoved(item) {
        this.props.onItemRemoved(item);

    }
}


export default WeatherSaved;




// WEBPACK FOOTER //
// ./src/WeatherSaved.jsx